import { render, staticRenderFns } from "./BotStats.vue?vue&type=template&id=beffab00&scoped=true"
import script from "./BotStats.vue?vue&type=script&lang=js"
export * from "./BotStats.vue?vue&type=script&lang=js"
import style0 from "./BotStats.vue?vue&type=style&index=0&id=beffab00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beffab00",
  null
  
)

export default component.exports